// extracted by mini-css-extract-plugin
export default {"panel":"panel_panel__Tugbd"};